import React from 'react';
import VideocamRoundedIcon from '@mui/icons-material/VideocamRounded';
import MediaDeviceSelectPill from './MediaDeviceSelectPill';
import {
  DEFAULT_CAMERA_ID,
  createStoredPreferenceHelpers,
} from './mediaDeviceSelectorUtils';

export const SESSION_STORAGE_KEY = 'oatrx.portalDelivery.selectedCamera';

const {
  defaultPreference,
  readPreference,
  persistPreference,
} = createStoredPreferenceHelpers({
  storageKey: SESSION_STORAGE_KEY,
  fallbackId: DEFAULT_CAMERA_ID,
  fallbackLabel: 'Default camera',
});

export const readStoredCameraPreference = readPreference;
export const persistCameraPreference = persistPreference;
export { DEFAULT_CAMERA_ID };

const CameraSelector = (props) => (
  <MediaDeviceSelectPill
    {...props}
    kind="videoinput"
    fallbackId={DEFAULT_CAMERA_ID}
    fallbackLabel={defaultPreference.label}
    pillLabel="Camera"
    Icon={VideocamRoundedIcon}
    readPreference={readPreference}
    persistPreference={persistPreference}
  />
);

export default CameraSelector;
